<template>
  <section id="pricing" class="pb-8 mt-10">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-card style="width: 100%" class="pb-10">
            <h1 class="text-center pt-6 font-weight-light display-2">
              Servicios
            </h1>
            <v-divider class="my-6"></v-divider>
            <v-row class="text-center" style="gap: 30px 0;">
              <v-col
                class="col-12 col-sm-6 col-md-4 pb-0"
                v-bind:class="{
                  'borde-separador':
                    $vuetify.breakpoint.mdAndUp && (idx + 1) % 3 !== 0,
                }"
                v-for="(service, idx) in services"
              >
                <Service
                  :Titulo="service.Titulo"
                  :Descripcion="service.Descripcion"
                  :IMGurl="service.Imagen"
                  :Detalles="service.Detalles"
                  :Index="idx"
                />
                <!-- <v-divider class="mx-4" v-if="!$vuetify.breakpoint.smAndUp"></v-divider> -->
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-rounded text-light">
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 144.54 17.34"
        preserveAspectRatio="none"
        fill="currentColor"
      >
        <path
          d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
        />
      </svg> -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
        fill="currentColor"
      >
        <path
          d="M0,64L80,90.7C160,117,320,171,480,181.3C640,192,800,160,960,138.7C1120,117,1280,107,1360,101.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        ></path>
      </svg>
    </div>
  </section>
</template>

<script>
import Service from "./Service";

export default {
  components: {
    Service,
  },
  data: () => ({
    services: [
      {
        Titulo: "Diseño",
        Descripcion:
          "Logre traducir en un documento formal la planificación del producto que desea concretar para echar andar su negocio.",
        Imagen: "diseño.svg",
        Detalles: [
          "Toma y validación de Requerimientos",
          "Definición de alcance",
          "Arquitectura Física y Lógica",
        ],
      },
      {
        Titulo: "Desarrollo",
        Descripcion:
          "Confíenos su proyecto, las necesidades de su empresa serán atendidas con la programación, implementación, prueba e integración del sistema.",
        Imagen: "desarrollo.svg",
        Detalles: [
          "Implementación de software",
          "Integración y Documentación",
          "Validación e Instalación",
        ],
      },
      {
        Titulo: "Mantenimiento",
        Descripcion:
          "Nos encargaremos de mantener todo su sistema en perfecto estado de funcionamiento.",
        Imagen: "mantencion.svg",
        Detalles: [
          "Mantenimiento correctivo",
          "Servidores de alta disponibilidad",
          "Mantenimiento Adaptativo",
        ],
      },
      {
        Titulo: "Hosting",
        Descripcion:
          "Mantenemos tu sitio web en línea, con un servicio de hosting de alta calidad.",
        Imagen: "hosting.svg",
        Detalles: [
          "Servicios de Hosting",
          "Servicios de Dominio",
          "Servicios de Correo",
          // "Soporte técnico 24/7",
        ],
      },
      {
        Titulo: "Desarrollo Web",
        Descripcion:
          "Diseñamos y desarrollamos sitios web a medida, con la mejor tecnología y con un diseño atractivo y funcional.",
        Imagen: "Website-designer-bro.svg",
        Detalles: [
          "Diseño Web",
          "Desarrollo Web",
          "Administración de contenidos",
          "Posicionamiento Web",
          // "Soporte técnico 24/7",
        ],
      },
    ],
    planos: [
      {
        title: "Básico",
        price: "R$100,00",
        img: "f1.png",
        features: [
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 1",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 2",
          },
          {
            icon: {
              text: "mdi-cancel",
              color: "red",
            },
            text: "Feature 3",
          },
          {
            icon: {
              text: "mdi-cancel",
              color: "red",
            },
            text: "Feature 4",
          },
        ],
      },
      {
        title: "Padrão",
        price: "R$150,00",
        img: "f2.png",
        features: [
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 1",
            color: "success",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 2",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 3",
            color: "success",
          },
          {
            icon: {
              text: "mdi-cancel",
              color: "red",
            },
            text: "Feature 4",
          },
        ],
      },
      {
        title: "Premium",
        price: "R$250,00",
        img: "f3.png",
        features: [
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 1",
            color: "success",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 2",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 3",
            color: "success",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 4",
            color: "success",
          },
        ],
      },
    ],
  }),
  computed: {
    size() {
      const size = { md: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
};
</script>

<style lang="scss">
$main_color: #283e79;

ul {
  font-size: 13px;
  line-height: 1.5em;
  margin: 5px 0 15px;
  padding: 0;

  li {
    list-style: none;
    position: relative;
    padding: 0 0 0 20px;
  }

  li {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 10px;
      height: 10px;
      background-color: $main_color;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-eeborder-radius: 50%;
    }
  }
}
</style>

<style scoped>
.borde-separador {
  border-right: 1px solid #e0e0e0;
}
.blue--text {
  color: #0d4e6c !important;
}
.header {
  background-color: #283e79;
  color: white;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-border-rounded svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #f4f7f5;
  z-index: -1;
}

#pricing {
  z-index: 0;
}

.content {
  z-index: 1;
}

svg {
  overflow: hidden;
}

section {
  position: relative;
}
</style>
